import React, { useState } from "react";
import styled from "styled-components";

import CogFuncExplorer from "./CogFuncExplorer/CogFuncExplorer";
import TypeSelector from "./TypeSelector";
import useWindowDimensions from "../utils/hooks/useWindowDimensions";

const Container = styled.div`
  .type-selectors-container {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 100;
  }
`;

const ParamControlsWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  ${({ radius }) => `
    transform: translate(-50%, ${radius}px);
    width: ${radius * 2}px;
  `}
`;

const TypeComparison = ({ paramStates, mbti1Obj, mbti2Obj }) => {
  const { width: windowWidth } = useWindowDimensions();
  const radius = windowWidth <= 500 ? windowWidth / 2 - 50 : 240;
  const [showShadowFunc, setShowShadowFunc] = useState(true);

  return (
    <Container className="type-explorer-container" {...{ radius }}>
      <div className="type-selectors-container">
        <TypeSelector mbtiObj={mbti1Obj} {...{ paramStates, radius }} />
        <TypeSelector mbtiObj={mbti2Obj} {...{ paramStates, radius }} />
      </div>
      <CogFuncExplorer mbtiObj={mbti1Obj} {...{ paramStates }} />
    </Container>
  );
};

export default TypeComparison;
